// extracted by mini-css-extract-plugin
module.exports = {"label":"styles_label__WfiZI","textarea":"styles_textarea__3g7yH","lg":"styles_lg__jucKZ","md":"styles_md__2Suv4"};